(function () {
      if (window.slrProductStickyAssetInitialized) return;
      window.slrProductStickyAssetInitialized = true;

      function initSticky(sticky) {
      if (!sticky || sticky.dataset.slrStickyInitialized === 'true') return;
      const configElement = sticky.querySelector('[data-slr-sticky-config]');
      if (!configElement) return;
      const config = JSON.parse(configElement.textContent);
      sticky.dataset.slrStickyInitialized = 'true';

      const addButton = sticky.querySelector('[data-slr-sticky-add]');
      const priceEl = sticky.querySelector('[data-slr-sticky-price]');
      const variantData = config.variants;
      const bodyVisibleClass = 'slr-product-sticky-visible';
      const bodyMobileClass = 'slr-product-sticky-mobile';

      const manualTriggerSelector = config.manualTriggerSelector;
      const fallbackScrollPercent = config.fallbackScrollPercent;

      let triggerPoint = 0;
      let ticking = false;

      function updateLayoutMode() {
        const stickyWidth = sticky.getBoundingClientRect().width || window.innerWidth || document.documentElement.clientWidth;
        const shouldUseMobileLayout =
          stickyWidth <= 700 ||
          window.innerWidth <= 990 ||
          document.documentElement.clientWidth <= 990;

        sticky.classList.toggle('slr-sticky-mobile-layout', shouldUseMobileLayout);
        document.body.classList.toggle(bodyMobileClass, shouldUseMobileLayout);
      }

      function getAbsoluteTop(element) {
        if (!element) return 0;
        return element.getBoundingClientRect().top + window.pageYOffset;
      }

      function safeQuerySelector(selector) {
        if (!selector || typeof selector !== 'string') return null;

        try {
          return document.querySelector(selector);
        } catch (error) {
          return null;
        }
      }

      function findMidThreeSection() {
        const manualTarget = safeQuerySelector(manualTriggerSelector);
        if (manualTarget) return manualTarget.closest('.shopify-section') || manualTarget;

        const allSections = Array.prototype.slice.call(
          document.querySelectorAll('.shopify-section, section, [id], [class]')
        );

        const midThreePatterns = [
          'mid.3',
          'mid-3',
          'mid_3',
          'mid 3',
          'mid3',
          'mid-three',
          'mid_three',
          'mid three',
          'product-mid3',
          'product-mid3-cta',
          'product_mid3',
          'product_mid3_cta'
        ];

        for (const element of allSections) {
          if (!element || element.contains(sticky)) continue;

          const id = (element.id || '').toLowerCase();
          const className = (typeof element.className === 'string' ? element.className : '').toLowerCase();
          const label = (element.getAttribute('data-section-type') || '').toLowerCase();
          const merged = id + ' ' + className + ' ' + label;

          if (midThreePatterns.some(function (pattern) { return merged.indexOf(pattern) !== -1; })) {
            return element.closest('.shopify-section') || element;
          }
        }

        return null;
      }

      function findSecondCtaFallback() {
        const ctaCandidates = Array.prototype.slice.call(
          document.querySelectorAll(
            'a[href*="/cart"], a[href*="/checkout"], button[name="add"], button[type="submit"], [data-slr-cta], [class*="cta"], [class*="button"]'
          )
        ).filter(function (element) {
          if (!element || sticky.contains(element)) return false;

          const rect = element.getBoundingClientRect();
          const style = window.getComputedStyle(element);

          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
          if (rect.width < 80 || rect.height < 24) return false;

          const text = (element.textContent || element.getAttribute('aria-label') || '').toLowerCase();

          return (
            text.indexOf('warenkorb') !== -1 ||
            text.indexOf('kasse') !== -1 ||
            text.indexOf('ebook') !== -1 ||
            text.indexOf('e-book') !== -1 ||
            text.indexOf('kaufen') !== -1 ||
            text.indexOf('anleitung') !== -1 ||
            element.querySelector('img')
          );
        });

        if (ctaCandidates.length >= 2) {
          return ctaCandidates[1].closest('.shopify-section') || ctaCandidates[1];
        }

        return null;
      }

      function calculateTriggerPoint() {
        const midThree = findMidThreeSection();
        const secondCta = midThree || findSecondCtaFallback();

        if (secondCta) {
          triggerPoint = getAbsoluteTop(secondCta) + secondCta.offsetHeight;
          return;
        }

        const documentHeight = Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight,
          document.body.offsetHeight,
          document.documentElement.offsetHeight
        );

        triggerPoint = Math.max(
          window.innerHeight * 1.15,
          documentHeight * fallbackScrollPercent
        );
      }

      function setStickyVisible(isVisible) {
        sticky.classList.toggle('is-visible', isVisible);
        document.body.classList.toggle(bodyVisibleClass, isVisible);
      }

      function updateStickyVisibility() {
        const shouldShow = window.pageYOffset >= triggerPoint;
        setStickyVisible(shouldShow);
      }

      function requestVisibilityUpdate() {
        if (ticking) return;

        ticking = true;

        window.requestAnimationFrame(function () {
          updateLayoutMode();
          updateStickyVisibility();
          ticking = false;
        });
      }

      function getCurrentVariantId() {
        const mainVariantInput =
          document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
          document.querySelector('select[name="id"]');

        if (mainVariantInput && mainVariantInput.value) {
          return mainVariantInput.value;
        }

        return config.initialVariantId;
      }

      function getCurrentVariant() {
        const variantId = getCurrentVariantId();

        return variantData.find(function (variant) {
          return String(variant.id) === String(variantId);
        });
      }

      function setButtonAvailable(isAvailable) {
        if (!addButton) return;

        if (isAvailable) {
          addButton.disabled = false;
          addButton.removeAttribute('aria-disabled');
          addButton.setAttribute('aria-label', addButton.getAttribute('data-default-text') || 'In den Warenkorb');
        } else {
          addButton.disabled = true;
          addButton.setAttribute('aria-disabled', 'true');
          addButton.setAttribute('aria-label', addButton.getAttribute('data-sold-out-text') || 'Nicht verfügbar');
        }
      }

      function formatMoneyFallback(cents) {
        const amount = Number(cents || 0) / 100;

        try {
          return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: config.currency
          }).format(amount);
        } catch (error) {
          return amount.toFixed(2).replace('.', ',') + ' ' + config.currency;
        }
      }

      function updateStickyFromMainForm() {
        const currentVariant = getCurrentVariant();
        if (!currentVariant) return;

        if (priceEl) {
          if (window.Shopify && typeof Shopify.formatMoney === 'function') {
            priceEl.innerHTML = Shopify.formatMoney(
              currentVariant.price,
              config.moneyFormat
            );
          } else {
            priceEl.innerHTML = formatMoneyFallback(currentVariant.price);
          }
        }

        setButtonAvailable(Boolean(currentVariant.available));
      }

      function openCartDrawerOrRedirect() {
        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');

        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
          return;
        }

        if (cartNotification && typeof cartNotification.open === 'function') {
          cartNotification.open();
          return;
        }

        window.location.href = '/cart';
      }

      function refreshCartUi() {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:change'));
      }

      function addCurrentVariantToCart() {
        const currentVariant = getCurrentVariant();
        const variantId = currentVariant && currentVariant.id;

        if (!variantId || !currentVariant.available || !addButton || addButton.disabled) return;

        addButton.disabled = true;
        addButton.setAttribute('aria-disabled', 'true');
        addButton.setAttribute('aria-label', addButton.getAttribute('data-loading-text') || 'Wird hinzugefügt');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart add failed');
            return response.json();
          })
          .then(function () {
            addButton.setAttribute('aria-label', addButton.getAttribute('data-added-text') || 'Hinzugefügt');
            refreshCartUi();

            window.setTimeout(openCartDrawerOrRedirect, 350);
            window.setTimeout(updateStickyFromMainForm, 1200);
          })
          .catch(function () {
            window.location.href = '/cart/add?id=' + encodeURIComponent(variantId) + '&quantity=1';
          });
      }

      updateLayoutMode();
      calculateTriggerPoint();
      updateStickyVisibility();
      updateStickyFromMainForm();

      window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });

      window.addEventListener('resize', function () {
        updateLayoutMode();
        calculateTriggerPoint();
        updateStickyVisibility();
      });

      window.addEventListener('load', function () {
        updateLayoutMode();
        calculateTriggerPoint();
        updateStickyVisibility();
      });

      document.addEventListener('shopify:section:load', function () {
        updateLayoutMode();
        calculateTriggerPoint();
        updateStickyVisibility();
      });

      document.addEventListener('change', function (event) {
        if (!event.target) return;

        if (
          event.target.name === 'id' ||
          event.target.matches('input[type="radio"], select')
        ) {
          window.setTimeout(updateStickyFromMainForm, 80);
        }
      });

      document.addEventListener('variant:change', function () {
        window.setTimeout(updateStickyFromMainForm, 80);
      });

      if (addButton) {
        addButton.addEventListener('click', addCurrentVariantToCart);
      }
      }

      function initAll(scope) {
        (scope || document).querySelectorAll('[data-slr-product-sticky]').forEach(initSticky);
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() { initAll(document); });
      } else {
        initAll(document);
      }
      document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
    })();
